module.exports = __webpack_public_path__ + "img/clickfunnels_4.28b2b72f.png";